<template>
  <b-modal id="success-modal-backbeat-bigger">
    <b-container>
      <template #modal-header></template>

      <b-row class="my-3">
        <div class="success-container">
          <h2>{{ this.$props.title }}</h2>
        </div>
      </b-row>
      <div>
        <div>
          <!-- case: RT -->
          <div v-if="this.$props.typeAction == 'RRT'">
            <p class="p2 mb-3">
              <strong>
                CUMPRIMENTO DA PRODUÇÃO MÍNIMA:
              </strong>
              o cooperado deverá obter a produção mínima nas últimas 12 competências (conforme o Regimento Interno Art. 138). 
            </p>
            <p class="p2 mb-3">
              <strong>
                PARTICIPAÇÃO ASSEMBLEIA:
              </strong>
               o cooperado deverá participar da última assembleia para receber o ganho adicional até a próxima assembleia e assim sucessivamente. 
            </p>
            <p class="p2 mb-3">
              <strong>
                OBRIGAÇÕES FINANCEIRAS:
              </strong>
                o cooperado deverá estar adimplente com todas as obrigações financeiras com a cooperativa (mensalidade e coparticipação do plano de saúde, seguros, alugueis, cota capital e etc). 
            </p>
            <p class="p-16-custom color-green-2 mb-5">
              <strong>Ganho adicional máximo do indicador: 1,00% </strong>
            </p>
          </div>
          <!-- case: PT -->
          <div v-if="this.$props.typeAction == 'PT'">
            <p class="p2 mb-3">
              <strong>
                "DISPONIBILIZAÇÃO DE HORÁRIOS PARA AGENDAMENTO PELO HUB" :
              </strong>
              o cooperado disponibilizará no mínimo vinte (20) agendas ao mês, de segunda a sexta-feira, durante horário comercial.
            </p>
            <p class="p-16-custom color-green-2 mb-5">
              <strong>Ganho adicional máximo do indicador: 2,00% </strong>
            </p>
          </div>
          <!-- case: IT -->
          <div v-if="this.$props.typeAction == 'IT'">
            <p class="p2 mb-3">
              No "RESULTADO DA ESPECIALIDADE"
              o cálculo é baseado no resultado dos cooperados da mesma especialidade e aplicado o percentil 80. Sendo assim o "RESULTADO DA ESPECIALIDADE" servirá como META para as próximas competências. 
            </p>
            <p class="p2 mb-3">
              Para atingir a META, o "RESULTADO INDIVIDUAL" deverá ser menor ou igual ao "RESULTADO DA ESPECIALIDADE". Neste formato, o cooperado poderá comparar o seu "RESULTADO INDIVIDUAL" com a sua especialidade.
            </p>
            <p class="p-16-custom color-green-2 mb-5">
              <strong>Ganho adicional máximo do indicador: 3,00% </strong>
            </p>
          </div>
        </div>
      </div>
    </b-container>
    <template #modal-footer>
      <b-button
        @click="$bvModal.hide('success-modal-backbeat-bigger')"
        class="ml-4"
        variant="primary"
      >
        {{ $props.buttonText ? $props.buttonText : "Ok" }}
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  props: ["description", "buttonText", "subdescription", "protocol", "title", "typeAction"],
  methods: {
    onTextLossRatio() {
      if (this.dataBackBeat?.isLossRatio)
        return `O índice de sinistralidade foi de ${this.dataBackBeat?.lossRatio}, ultrapassando 
                     o valor máximo de ${this.dataBackBeat?.goal} necessário para atingir a meta.`;
      else
        return `O indice de sinistralidade foi de ${this.dataBackBeat?.lossRatio}, mantendo um valor
                      menor que ${this.dataBackBeat?.goal}, assim atingindo a meta.`;
    },
  }
};
</script>

<style lang="scss">
@media (min-width: 576px) {
  #success-modal-backbeat-bigger .modal-dialog {
    max-width: 800px;
    margin: 1.75rem auto;
  }
}
.p-16-custom {
  font-size: multiplier-default-font-size(4); // 14
}
</style>
<style lang="scss" scoped>

</style>